(ns manage.ad-variant.creation.core.exit-modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            ["src/svg/inform/info-circle.svg$default" :as InfoIcon]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation]]
            [manage.ad-variant.creation.content.hooks :as h]
            [manage.ad-variant.queries :as q]
            [manage.content-variant-page.queries :as content-queries]
            [re-frame.core :as rf]
            [uix.core :refer [$]]
            [uix.re-frame :refer [use-subscribe]]))

(def required-steps-messages
  {:template "Add templates"
   :feed "Import a feed"
   :placeholder-mapping "Map feed columns to template placeholders"})

(def changes-messages
  {:template "Template changes"
   :feed "Feed changes"
   :placeholder-mapping "Placeholder mapping changes"
   :inline-edits "Inline content edits"})

(defmodal ad-variant-creation-setup-incomplete :ad-variant/setup-incomplete
  [{:keys [close-creation setup-complete?]}]
  (let [no-steps-completed? (every? false? (vals setup-complete?))]
    ($ modal-v2
       {:title "Leaving ad variant setup"
        :icon ($ SvgIcon {:color "warning"}
                 ($ AlertIcon))
        :footer ($ Stack {:direction "row" :gap 1}
                   ($ Button {:variant "text"
                              :sx #js {:color "text.primary"}
                              :onClick #(rf/dispatch [:modal/close])}
                      "Back to ad variant setup")
                   ($ Button {:variant "contained"
                              :color "warning"
                              :onClick #(do (rf/dispatch [:modal/close])
                                            (close-creation))}
                      (if no-steps-completed?
                        "Close"
                        "Save and close")))}
       ($ :span "Your ad variants were not created. To create ad variants, please complete the following steps:")
       ($ :ul
          (for [[step step-complete?] setup-complete?
                :when (not step-complete?)]
            ($ :li {:key step} (get required-steps-messages step))))
       ($ :span "Your changes are autosaved, you can finish this later."))))

(defmodal ad-variant-creation-unapplied-changes :ad-variant/unapplied-changes
  [{:keys [close-creation unapplied-changes feed-id]}]
  (let [url-context (use-subscribe [:url-context])
        {trigger-feed-import :mutate} (use-mutation (content-queries/trigger-feed-import-mutation url-context feed-id))
        {trigger-ad-variants :mutate} (use-mutation (q/trigger-ad-variants-mutation url-context feed-id))
        can-safely-trigger-feed-import? (h/use-can-safely-trigger-feed-import? (assoc url-context :feed-id feed-id))]
    ($ modal-v2
       {:title "Ad variants changes not applied"
        :icon ($ SvgIcon {:color "primary"}
                 ($ InfoIcon))
        :footer ($ Stack {:direction "row" :gap 1}
                   ($ Button {:variant "text"
                              :sx #js {:color "text.primary"}
                              :onClick #(do (rf/dispatch [:modal/close])
                                            (close-creation))}
                      "Leave without updating")
                   ($ Button {:variant "contained"
                              :onClick #(do (rf/dispatch [:modal/close])
                                            (close-creation)
                                            (if can-safely-trigger-feed-import?
                                              (trigger-feed-import {:trigger-ad-variants? true})
                                              (trigger-ad-variants)))}
                      "Leave and update"))}
       ($ :span "The following changes were made, but your ad variants haven't been updated yet:")
       ($ :ul
          (for [[change is-changed?] unapplied-changes
                :when is-changed?]
            ($ :li {:key change} (get changes-messages change)))))))
